import { Layout } 			from './../../services/Layout'
import { Version } 			from './../../services/Version'
import { Creative } 			from './../../services/Creative'

// Порог прилипания к стандартной высоте (в пикселях)
const SNAP_THRESHOLD = 10;
// Если при драге высота становится меньше этого значения - компонент сворачивается до иконки
const COLLAPSE_HEIGHT = 50;
// Доля от доступной высоты окна (без хидера и тулбокса) которую максимально может занимать компонент
const MAX_HEIGHT_RATIO = 0.7;
// Максимальная доля высоты компонента для textarea и максимальное количество строк
const TEXTAREA_MAX_HEIGHT_RATIO = 0.33;
const TEXTAREA_MAX_LINES = 10;
const TEXTAREA_LINE_HEIGHT = 18;
const TEXTAREA_VERTICAL_OFFSET = 14;

// Примесь компонента AIAgent.vue: высота чата (сохранение для версии и размера превью), изменение высоты драгом за верхний край, сворачивание до иконки и высота textarea
export default {
	data() {

		this.resizeProcess = null;

		return {
			collapsed: false,
			resizing: false,
			height: Layout.aiChatDefaultHeight,
			collapsedHeight: Layout.aiChatCollapsedHeight
		};

	},
	methods: {
		restoreHeight() {

			let storageKey = this.getHeightStorageKey();

			if (!storageKey) return;

			let storedHeight = parseInt(window.localStorage.getItem(storageKey));

			if (storedHeight) {

				// Отрицательное значение означает что компонент был свёрнут (модуль значения - высота до сворачивания)
				this.collapsed = storedHeight < 0;
				this.height = Math.abs(storedHeight);

			} else {

				this.collapsed = false;
				this.height = Layout.aiChatDefaultHeight;

			}

			this.clampHeight();

			Layout.setAIAgentHeight(this.height, this.collapsed);

		},
		getHeightStorageKey() {

			if (!Version.SelectedVersion?.id) return null;

			let versionId = Version.SelectedVersion.id;
			let sizeKey = Layout.getPreviewSizeKey();
			let key = `ai-chat-height:${versionId}:${sizeKey}`;

			if (Creative.SelectedCreative?.type === 'playable') {

				let device = Layout.previewDevice;
				let orientation = Layout.previewOrientation?.[device] || 'portrait';

				key += `:${device}:${orientation}`;

			}

			return key;

		},
		clampHeight() {

			let maxHeight = this.getMaxHeight();

			if (this.height > maxHeight) this.height = maxHeight;
			if (this.height < COLLAPSE_HEIGHT) this.height = COLLAPSE_HEIGHT;

			this.$nextTick(() => this.autoResizeTextarea());

			Layout.setAIAgentHeight(this.height, this.collapsed);

		},
		getMaxHeight() {

			return Math.floor((window.innerHeight - Layout.headerHeight - Layout.subHeaderHeight) * MAX_HEIGHT_RATIO);

		},
		startResize(e) {

			if (e.button !== 0) return;

			e.preventDefault();

			this.resizing = true;

			Broadcast.call("Preview Drag State Changed", [true]);

			this.resizeProcess = {
				startY: e.clientY,
				startHeight: this.collapsed ? 0 : this.height,
				startCollapsed: this.collapsed,
				moved: false
			};

			this.onResizeMove = e => this.processResize(e);
			this.onResizeStop = () => this.stopResize();

			window.addEventListener('mousemove', this.onResizeMove);
			window.addEventListener('mouseup', this.onResizeStop);

		},
		processResize(e) {

			if (!this.resizeProcess) return;

			let deltaY = this.resizeProcess.startY - e.clientY;

			if (Math.abs(deltaY) > 3) this.resizeProcess.moved = true;

			let newHeight = Math.min(this.resizeProcess.startHeight + deltaY, this.getMaxHeight());

			// Прилипание к стандартной высоте
			if (Math.abs(newHeight - Layout.aiChatDefaultHeight) <= SNAP_THRESHOLD) {

				newHeight = Layout.aiChatDefaultHeight;

			}

			// Если тянем ниже минимальной высоты - сворачиваем компонент до иконки
			if (newHeight < COLLAPSE_HEIGHT) {

				this.collapsed = true;

			}
			else {

				this.collapsed = false;
				this.height = newHeight;

			}

			Layout.setAIAgentHeight(this.height, this.collapsed);

		},
		stopResize() {

			if (!this.resizeProcess) return;

			window.removeEventListener('mousemove', this.onResizeMove);
			window.removeEventListener('mouseup', this.onResizeStop);

			Broadcast.call("Preview Drag State Changed", [false]);

			// Клик по иконке свёрнутого чата (без драга) - разворачиваем до прежней высоты
			if (this.resizeProcess.startCollapsed && !this.resizeProcess.moved) {
				this.collapsed = false;
				this.height = Layout.aiChatDefaultHeight;
			}

			this.resizing = false;
			this.resizeProcess = null;

			this.clampHeight();

			this.saveHeight();

			Layout.setAIAgentHeight(this.height, this.collapsed);

		},
		saveHeight() {

			let storageKey = this.getHeightStorageKey();

			if (!storageKey) return;

			window.localStorage.setItem(storageKey, (this.collapsed ? -this.height : this.height) + '');

		},
		autoResizeTextarea() {

			let textarea = this.$refs.textarea;

			if (!textarea) return;

			textarea.style.height = 'auto';
			textarea.style.height = Math.min(textarea.scrollHeight, this.getTextareaMaxHeight()) + 'px';

		},
		getTextareaMaxHeight() {

			// Textarea растёт вместе с текстом, но не более 33% высоты компонента и не более 10 строк
			let maxHeightByRatio = Math.floor(this.height * TEXTAREA_MAX_HEIGHT_RATIO);
			let maxHeightByLines = TEXTAREA_MAX_LINES * TEXTAREA_LINE_HEIGHT + TEXTAREA_VERTICAL_OFFSET;

			return Math.min(maxHeightByRatio, maxHeightByLines);

		}
	}
}
